import { render, staticRenderFns } from "./AppRadioGroup.vue?vue&type=template&id=03185fe6&scoped=true&"
import script from "./AppRadioGroup.vue?vue&type=script&lang=js&"
export * from "./AppRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03185fe6",
  null
  
)

export default component.exports